var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3078 4.69238H4.69238V19.3078H19.3078V4.69238ZM4.69238 3.69238H3.69238V4.69238V19.3078V20.3078H4.69238H19.3078H20.3078V19.3078V4.69238V3.69238H19.3078H4.69238Z",
    fill: "#F9FAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12L16 12",
    stroke: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.84a3d9090cdfd9156800539a42e444d1.svg";
export { ForwardRef as ReactComponent };